// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"webpack_sharing_consume_default_react_react":"ab46814b7cc93f0ce2cc","src_bootstrap_js":"e10e29b3b3ca41eaaee9","vendors-node_modules_react-dom_index_js":"2b3648f61bed7da3a0ce","vendors-node_modules_react_index_js":"b65aee2b4c01b361c0a5"}[chunkId] + ".js";
};